export default "__VITE_ASSET__wNXaz3pJ__"